// Parent Package : https:/ / github.com / robpataki / brewser;

export default function getDeviceDetails(uaString) {
  const NOT_AVAILABLE = "N/A";

  const DEVICES = {
    phone: "phone",
    tablet: "tablet",
    desktop: "desktop",
  };
  const BROWSERS = {
    edge: "Edge",
    chrome: "Chrome",
    brave: "Brave",
    safari: "Safari",
    opera: "Opera",
    firefox: "Firefox",
    ie: "Internet Explorer",
    silk: "Silk",
    kindle: "Kindle",
    other: "Other",
  };

  const ua = (uaString ?? globalThis.navigator.userAgent).toLowerCase();

  function isOSWin() {
    return /(windows|windows nt)/g.test(ua);
  }

  function isOSMac() {
    return /(macintosh|intel mac|os x)/g.test(ua);
  }

  function isOSiOS() {
    return /(ipad|iphone|ipod)/g.test(ua);
  }

  function isOSAndroid() {
    return ua.indexOf("android") > -1;
  }

  function detectOS() {
    if (isOSWin()) {
      return "Windows";
    }
    if (isOSiOS()) {
      return "iOS";
    }
    if (isOSAndroid()) {
      return "Android";
    }
    if (isOSMac()) {
      return "Mac OS X";
    }

    return NOT_AVAILABLE;
  }

  function hasTouch() {
    return (
      !!("ontouchstart" in globalThis) ||
      (!!("onmsgesturechange" in globalThis) &&
        !!globalThis?.navigator?.maxTouchPoints)
    );
  }

  function detectDeviceType() {
    const screenWidth = globalThis?.screen?.width;

    if (
      /(nexus 7|tablet|ipad|kindle|Macintosh)/g.test(ua) ||
      (hasTouch() && screenWidth >= 600)
    ) {
      return DEVICES.tablet;
    }
    if (hasTouch() && screenWidth < 600) {
      return DEVICES.phone;
    }

    return DEVICES.desktop;
  }

  function isBrowserIE() {
    return /(msie|iemobile|ie)/g.test(ua);
  }

  function isBrowserEdge() {
    return /(edg)/g.test(ua);
  }

  function isBrowserFirefox() {
    return ua.indexOf("firefox") > -1;
  }

  function isBrowserOpera() {
    return /(opera|opr)/g.test(ua);
  }

  function isBrowserSafari() {
    return (
      ua.indexOf("safari") > -1 &&
      !isBrowserOpera() &&
      !isBrowserChrome() &&
      !isOSAndroid()
    );
  }

  function isBrowserChrome() {
    return (
      (ua.indexOf("chrome") > -1 || ua.indexOf("crios") > -1) &&
      !isBrowserOpera()
    );
  }

  function isBrowserBrave() {
    // @ts-ignore
    return isBrowserChrome() && (navigator.brave || ua.indexOf("brave") > -1);
  }

  function isBrowserSilk() {
    return /(silk)/g.test(ua);
  }

  function isBrowserKindle() {
    return /(kindle)/g.test(ua);
  }

  function getBrowserVersion(browserKey) {
    const regex = new RegExp(`${browserKey}[ /]([\\d.]+)`);
    const match = ua.match(regex);

    return match ? match[1] : NOT_AVAILABLE;
  }

  function detectBrowserType() {
    if (isBrowserBrave()) {
      return { name: BROWSERS.brave, version: getBrowserVersion("chrome") };
    }
    if (isBrowserKindle()) {
      return { name: BROWSERS.kindle, version: getBrowserVersion("kindle") };
    }
    if (isBrowserOpera()) {
      return { name: BROWSERS.opera, version: getBrowserVersion("opr") };
    }
    if (isBrowserFirefox()) {
      return { name: BROWSERS.firefox, version: getBrowserVersion("firefox") };
    }
    if (isBrowserEdge()) {
      return { name: BROWSERS.edge, version: getBrowserVersion("edg") };
    }
    if (isBrowserChrome()) {
      return {
        name: BROWSERS.chrome,
        version: getBrowserVersion("chrome|crios"),
      };
    }
    if (isBrowserSilk()) {
      return { name: BROWSERS.silk, version: getBrowserVersion("silk") };
    }
    if (isBrowserSafari()) {
      return { name: BROWSERS.safari, version: getBrowserVersion("version") };
    }
    if (isBrowserIE()) {
      return { name: BROWSERS.ie, version: getBrowserVersion("msie|iemobile") };
    }

    return { name: BROWSERS.other, version: NOT_AVAILABLE };
  }

  const browserInfo = detectBrowserType();

  return {
    name: browserInfo.name,
    version: browserInfo.version,
    type: detectOS(),
    category: detectDeviceType(),
  };
}
